import { aludraApi } from 'api/axios'
import { mdl04Urls } from './mdl04.urls'

export const listPrices = async payload => {
  return aludraApi.post(mdl04Urls.getListPrices, payload)
}

export const cochezListPrices = async payload => {
  const { data } = await aludraApi.post(mdl04Urls.getCochezListPrices, payload)
  return data
}

export const saveListPrices = async payload => {
  return aludraApi.post(mdl04Urls.saveListPrices, payload)
}

export const deleteListPrices = async payload => {
  return aludraApi.delete(mdl04Urls.deleteListPrice + payload)
}

export const listPricesByCustomer = async payload => {
  return aludraApi.post(mdl04Urls.getListPricesByCustomer, payload)
}

export const listBranches = async payload => {
  return aludraApi.post(mdl04Urls.branchesURL, payload)
}

export const listSupplier = async payload => {
  return aludraApi.post(mdl04Urls.supplier, payload)
}

export const listDepartments = async payload => {
  const { data } = await aludraApi.post(mdl04Urls.allDepartments, payload)
  const response = data?.Data || []
  return response
}

export const productDetaill = async payload => {
  return aludraApi.post(mdl04Urls.productDetailURL, payload)
}

export const inventoryDetail = async payload => {
  return aludraApi.post(mdl04Urls.inventarioURL, payload)
}

export const extendedWarranty = async => {
  return aludraApi.get(mdl04Urls.warantyURL)
}
